<template>
  <li
    v-if="canViewVerticalNavMenuLink(item) && item.visible"
    class="nav-item"
    :class="{
      active: isActive,
      disabled: item.disabled,
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
      :class="{ 'childtitlestyle': Boolean(!item.customicon && !item.icon && !item.komicon), 'is-level-3': item.isLevel3 }"
    >
      <div
        v-if="item.customicon"
        v-html="item.customicon"
      />
      <span
        v-else-if="item.komicon"
        :class="item.komicon"
        style="margin-right: 1.1rem; font-size: 1.5rem;"
      />
      <feather-icon
        v-else
        :icon="item.icon || (!Boolean(item.hasParent) ? 'CircleIcon' : '')"
      />
      <span
        class="menu-title text-truncate"
        :class="{ 'font-bold text-dark': Boolean(item.fontBold) }"
      >{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
      <b-badge
        v-if="item.route === 'partner' && $store.state.talentPool.newRegister"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ $store.state.talentPool.newRegister }}
      </b-badge>
      <b-badge
        v-if="item.route === 'komads-whitelisted-topup'"
        pill
        variant="primary"
        class="ml-auto"
      >
        {{ $store.state.komadsWhitelist.pendingTopup }}
      </b-badge>
      <b-badge
        v-if="item.route === 'komads-setup-whitelisted'"
        pill
        variant="primary"
        class="ml-auto"
      >
        {{ $store.state.komadsWhitelist.pendingWhitelistAccountRequest }}
      </b-badge>
      <b-badge
        v-if="item.route === 'komads-account-issues' && $store.state.komadsWhitelist.pendingWhitelistAccountIssue > 0"
        pill
        variant="primary"
        class="ml-auto"
      >
        {{ $store.state.komadsWhitelist.pendingWhitelistAccountIssue }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(
      props.item,
    )
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
}
</script>
